import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthModule } from './features/auth/auth.module';
import { authGuardGuard } from './core/auth/auth-guard.guard';
import { rootRedirectGuard } from './core/auth/root-redirect.guard';
import { trainerGuard } from './core/auth/trainer.guard';
import { golferGuard } from './core/auth/golfer.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./root/root.component').then(m => m.RootComponent),
    canActivate: [rootRedirectGuard]
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./features/activities/activities.module').then(m => m.ActivitiesModule),
    canActivate: [authGuardGuard]
  },
  {
    path: 'activities',
    loadComponent: () =>
      import('./features/home/home.page').then(m => m.HomePage),
    canActivate: [authGuardGuard]
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./features/public/public.module').then(m => m.PublicPageModule)
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'activity/:slug',
    loadComponent: () => import('./features/activity-detail/activity-detail.component').then(m => m.ActivityDetailComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'myprofile',
    loadComponent: () =>
      import('./features/myprofile/myprofile.component').then(m => m.MyprofileComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'profile-menu-mobile',
    loadComponent: () =>
      import('./features/profile-menu-mobile/profile-menu-mobile.component').then(m => m.ProfileMenuMobileComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'add-activity',
    loadComponent: () =>
      import('./features/add-activity/add-activity.component').then(m => m.AddActivityComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'update-activity',
    loadComponent: () =>
      import('./features/update-activity/update-activity.component').then(m => m.UpdateActivityComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'notification-settings',
    loadComponent: () =>
      import('./features/notification-settings/notification-settings.component').then(m => m.NotificationSettingsComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'list-participated/:id',
    loadComponent: () =>
      import('./features/list-participated/list-participated.component').then(m => m.ListParticipatedComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'list-requests/:id',
    loadComponent: () =>
      import('./features/list-requests/list-requests.component').then(m => m.ListRequestsComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'contactus',
    loadComponent: () =>
      import('./features/contactus/contactus.component').then(m => m.ContactusComponent)
  },
  {
    path: 'cms/:cmsslug',
    loadComponent: () =>
      import('./features/cmspages/cmspages.component').then(m => m.CmspagesComponent)
  },
  {
    path: 'account-settings',
    loadComponent: () =>
      import('./features/account-settings/account-settings.component').then(m => m.AccountSettingsComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'schedule',
    loadComponent: () =>
      import('./features/my-activities/my-activities.component').then(m => m.MyActivitiesComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'messages',
    loadComponent: () =>
      import('./features/my-inbox/my-inbox.component').then(m => m.MyInboxComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'chat-detail/:chat_id',
    loadComponent: () =>
      import('./features/chat-detail/chat-detail.component').then(m => m.ChatDetailComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'explore-activity',
    loadComponent: () =>
      import('./features/explore-activity/explore-activity.component').then(m => m.ExploreActivityComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'viewprofile/:userId',
    loadComponent: () =>
      import('./features/viewprofile/viewprofile.component').then(m => m.ViewprofileComponent),
      canActivate: [authGuardGuard]
  },
  {
    path: 'edit-profile-app',
    loadComponent: () =>
    import('./features/edit-profile-app/edit-profile-app.component').then(m => m.EditProfileAppComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'update-activity/:slug',
    loadComponent: () =>
      import('./features/update-activity/update-activity.component').then(m => m.UpdateActivityComponent),
    canActivate: [authGuardGuard]
  },

  {
    path: 'zoom-meeting',
    loadComponent: () =>
    import('./features/zoom-meeting/zoom-meeting.component').then(m => m.ZoomMeetingComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'complete-profile',
    loadComponent: () =>
    import('./features/auth/complete-profile/complete-profile.component').then(m => m.CompleteProfileComponent),
    canActivate: [authGuardGuard]
  },
  {
    path: 'trainer',
    loadChildren: () =>
      import('./features/trainer/trainer.module').then(m => m.TrainerModule),
    canActivate: [trainerGuard]
  },
  {
    path: 'training',
    loadChildren: () =>
      import('./features/golfer/golfer.module').then(m => m.GolferModule),
    canActivate: [golferGuard]
  },
  // Unknown paths → base URL (avoids blank router-outlet)
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: "reload" })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
